import {Component, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {mergeMap} from 'rxjs/operators';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

import {languagesConst} from '@profile/components/profile/constants/languages.const';
import {ProfileService} from '@profile/profile.service';
import {Doctor} from '@core/interfaces/doctor/doctor.interface';

@UntilDestroy()

@Component({
  selector: 'app-language-select',
  templateUrl: './language-select.component.html',
  styleUrls: ['./language-select.component.scss']
})
export class LanguageSelectComponent implements OnInit {
  languages = languagesConst;

  lang = new FormControl('');
  profile: Doctor;

  constructor(
    private profileService: ProfileService,
    private translateService: TranslateService,
  ) {
  }

  ngOnInit(): void {
    this.getProfile();
  }

  manageProfile(event): void {
    this.profileService.patchLanguage(event.language)
      .pipe(
        mergeMap(() => this.profileService.loadProfile()),
        untilDestroyed(this)
      )
      .subscribe();
  }

  private getProfile(): void {
    this.profileService.profile$
      .pipe(untilDestroyed(this))
      .subscribe((profile: Doctor) => {
        this.profile = profile;
        this.lang.patchValue(this.profile?.lang || this.translateService.getDefaultLang());
      });
  }
}
